import { observable } from 'mobx';
import moment from 'moment';
import type { Moment } from '../lib/moment';

const insuranceProducts: Record<string, string> = {
  overseas_travel_accident: '海外旅行傷害保険'
};

export type InsuranceProductType = keyof typeof insuranceProducts;

export type InsuranceElementResponseArgs = {
  id: number;
  product_text: string;
  product?: string;
  content?: string;
  order_item_id?: number;
  started_at?: string;
  ended_at?: string;
};

export type InsuranceElementArgs = {
  id: number;
  productText: string;
  product?: string;
  content?: string;
  orderItemId?: number;
  startedAt?: Moment;
  endedAt?: Moment;
};

export const convertInsuranceElementResponseToArgs = (response: InsuranceElementResponseArgs) => {
  const args: InsuranceElementArgs = {
    id: response.id,
    productText: response.product_text,
    product: response.product,
    content: response.content,
    orderItemId: response.order_item_id,
    startedAt: response.started_at ? moment(response.started_at) : undefined,
    endedAt: response.ended_at ? moment(response.ended_at) : undefined
  };
  return args;
};

export default class InsuranceElement {
  @observable id: number;
  @observable productText: string;
  @observable product?: string;
  @observable content?: string;
  @observable orderItemId?: number;
  @observable startedAt?: Moment;
  @observable endedAt?: Moment;

  constructor(args: InsuranceElementArgs) {
    this.id = args.id;
    this.productText = args.productText;
    this.product = args.product;
    this.content = args.content;
    this.orderItemId = args.orderItemId;
    this.startedAt = args.startedAt;
    this.endedAt = args.endedAt;
  }

  get type() {
    return 'insurance';
  }

  get startDate() {
    return null;
  }

  get endDate() {
    return null;
  }

  get title() {
    return '保険';
  }

  get summary() {
    return `[保険] ${this.productText}`;
  }

  get name() {
    return this.productText;
  }

  // TODO: js/src/domain/order_item2.tsでフォールバックしてるから不要
  get mappingDescription(): string {
    return this.title;
  }

  detail() {
    return '';
  }

  validationErrors(_orderItemStatus?: number): string[] {
    const errors: string[] = [];

    if (!this.product) {
      errors.push('保険の商品を入力してください。');
    }

    if (!this.content) {
      errors.push('保険の内容を入力してください。');
    }

    if (this.endedAt && this.startedAt && this.endedAt < this.startedAt) {
      errors.push('終了日は開始日以降を指定してください。');
    }

    return errors;
  }

  get updateParams() {
    return {
      type: this.type,
      product: this.product,
      content: this.content,
      order_item_id: this.orderItemId,
      started_at: this.startedAt?.format('YYYY-MM-DD HH:mm:ss'),
      ended_at: this.endedAt?.format('YYYY-MM-DD HH:mm:ss')
    };
  }

  get description(): string {
    return `<${this.title}>
    ■商品：${this.product && insuranceProducts[this.product]}
    ■内容
    ${this.content}
    ■開始日時：${this.startedAt?.format('YYYY/MM/DD HH:mm:ss')}
    ■終了日時：${this.endedAt?.format('YYYY/MM/DD HH:mm:ss')}
    `;
  }

  get startTime() {
    return this.startedAt;
  }

  get endTime() {
    return this.endedAt;
  }
}
